import { searchCustomers } from "../../../../HTTPRequests/OrderRequests";
import Customer from "../../../../Models/Customer";
import debouncer from "../../../../Utilities/debouncer";
import Mediator from "../../../../Utilities/Mediator";
import OrderHandler from "../../OrderHandler";
import AddNewCustomer from "./AddNewCustomer";
import AutoCompleteCustomer from "./AutoCompleteCustomer";

export default class SearchCustomer {
	customers: Array<Customer>;
	searchCustomer: HTMLDivElement;
	nameInput: HTMLInputElement;
	phoneInput: HTMLInputElement;
	inputsDiv: HTMLDivElement;
	searchValue: string;
	searchByName: boolean;
	addCustomerHandler: AddNewCustomer;

	constructor() {
		this.searchCustomer = document.querySelector(".search-customer");
		this.inputsDiv = this.searchCustomer.querySelector("#create-customer-inputs");
		this.nameInput = this.inputsDiv.querySelector("input[name='name']");
		this.phoneInput = this.inputsDiv.querySelector("#phone");

		this.init();
	}

	private init() {
		this.customers = new Array<Customer>();
		this.addCustomerHandler = new AddNewCustomer(this.inputsDiv);

		if (!OrderHandler.isDibsEnabled) {
			this.addAutoCompleteListeners();
			Mediator.on("customerSelected", () => this.closeAllLists());
		}
	}

	private addAutoCompleteListeners() {
		const debounce = debouncer(this.searchCustomers.bind(this), 700, false);

		this.nameInput.oninput = (event) => {
			if ((event.target["value"]).trim() != this.searchValue) {
				debounce(event);
				this.searchByName = true;
				this.addCustomerHandler.validateName();
				this.addCustomerHandler.validatePhone();
			}
		}

		this.phoneInput.oninput = (event) => {
			if ((event.target["value"]).trim() != this.searchValue) {
				debounce(event);
				this.searchByName = false;
				this.addCustomerHandler.validateName();
				this.addCustomerHandler.validatePhone();
			}
		}

		this.addCloseListOnWindowClickListener();
		this.addCloseListOnWindowScrollListener();
	}

	private searchCustomers() {
		this.searchValue = this.SearchValue;
		searchCustomers(encodeURIComponent(this.SearchValue), this.searchByName)
			.then((response: Array<Customer>) => {
				this.customers = response ?? new Array<Customer>();
				this.closeAllLists();
				if (this.customers.length > 0) {
					const input = this.searchByName ? this.nameInput : this.phoneInput;
					new AutoCompleteCustomer(this.customers, input);
				}

			}, () => { // backend error
				this.customers = new Array<Customer>();
				this.closeAllLists();
			});
	}

	private get SearchValue(): string {
		return this.searchByName ? this.nameInput?.value ?? "" : this.phoneInput?.value ?? "";
	}

	private addCloseListOnWindowClickListener() {
		document.body.onclick = (event) => {
			this.closeAllLists(event.target);
		}
	}

	private addCloseListOnWindowScrollListener() {
		const createView: HTMLDivElement = document.querySelector(".create-order div");
		createView.onscroll = (event) => {
			this.closeAllLists(event.target);
		}
	}

	private closeAllLists(elemnet?: EventTarget) {
		const autoCompleteItems: HTMLCollection = document.getElementsByClassName("autocomplete-items");

		for (let i = 0; i < autoCompleteItems.length; i++) {
			if (elemnet != autoCompleteItems[i] && elemnet != this.nameInput && elemnet != this.phoneInput) {
				autoCompleteItems[i].parentNode.removeChild(autoCompleteItems[i]);
			}
		}
	}
}
